export default "__VITE_ASSET__DKYlBZiZ__"